export interface DecouplingLoginResponse {
  encryptedPassword?: string;
  limitsExpired?: boolean;
  isTill?: boolean;
  playerUserName: string;
  balance: number;
  lastLogin?: Date;
  lastChangePassword?: Date;
  bgtUserId: number;
  isProhibited?: boolean;
  activeSmsEmail?: boolean;
  casinoLossLimit?: number;
  casinoSpendingLimit?: number;
  casinoTimeLimit?: number;
  depositDayLimit?: number;
  depositMonthLimit?: number;
  depositWeekLimit?: number;
  documentationVerification?: boolean;
  email: string;
  id: string;
  registrationDate: Date;
  userRegion: number;
  userCardNumber?: string;
  modifDateRegulatorFeature?: Date;
  firstDeposit?: boolean;
  firstDepositDate?: Date;
  alertSelfExclusion?: number;
  fiveLoginOK?: boolean;
  isForbidden?: boolean;
  isPPT?: boolean;
  canRevocate?: boolean;
  csrfControl?: string;
  acceptanceComunication?: boolean;
  terminationCodereDecision?: boolean;
}

export enum AutologinStatus {
  LOGGED,
  NOTLOGGED,
  SESSIONOUT,
  SESSIONERROR,
}
